<template>
  <button class="btn"
          :class="{
            'btn--hovered' : isHovered && !$store.state.isMobile,
            'btn--bordered' : bordered,
            'btn--small' : small,
            'btn--behance' : isFromBehance
          }"
          @click="$emit('click')"
          @mouseenter="mouseIn"
          @mouseleave="mouseOut"
  >
    <span>
      {{ label }}
    </span>
    <span v-if="!$store.state.isMobile" class="btn__hover">
      <span class="btn__label-wrapper">
        {{ label }}
      </span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'MainBtn',
  data () {
    return {
      isHovered: false
    }
  },
  props: {
    label: {
      type: String,
      default: 'Abrir Projeto'
    },
    bordered: Boolean,
    small: Boolean,
    isFromBehance: Boolean
  },
  methods: {
    mouseIn () {
      this.isHovered = true
      this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'pointer')
    },
    mouseOut () {
      this.isHovered = false
      this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'default')
    }
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  .btn
    @apply relative inline-block overflow-hidden px-3 py-2
    font-size: 2.20rem
    cursor: none
    &__hover
      @apply absolute pin-t pin-r bg-black text-white overflow-hidden w-full h-full
      transform: translateX(-100%)
    &__label-wrapper
      @apply absolute pin-t pin-r w-full h-full inline-flex items-center justify-center
      transform: translateX(100%)
    &__hover, &__label-wrapper
      transition: transform .4s cubic-bezier(.56,.01,.55,.86)
    &--hovered
      .btn
        &__hover, &__label-wrapper
          transform: translateX(0)
    &--bordered
      @apply border-2 border-black
    &--small
      @apply text-2xl
    &--behance
      @apply px-1
      @screen lg
        @apply px-3
</style>
